import { useTranslation } from "react-i18next";

import { Arrange, Column, Columns, Typography, Link } from "@aviary";
import { emersonRoutes } from "@emerson/data/emersonRoutes";
import { useEmersonCatalogParams } from "@emerson/hooks/useEmersonCatalogParams/useEmersonCatalogParams";
import { l } from "@emerson/locales/i18n";
import { getParamsString } from "@shared/hooks/useUrlParams/useUrlParams";
import type { Brand } from "@shared/types/graphqlGenerated";

import * as styles from "./ProductNameAndSku.styles";

type BrandType = Pick<Brand, "id" | "name">;

interface Props {
  productName: string;
  sku: string;
  vendorItemCode: string;
  brand: BrandType;
}

const ProductNameAndSku = ({ productName, sku, vendorItemCode, brand }: Props) => {
  const { t } = useTranslation();
  const [catalogParams] = useEmersonCatalogParams();

  const getBrandPath = () => {
    const brandParams = getParamsString({
      ...catalogParams,
      brands: [{ id: brand.id, name: brand.name }],
    });

    return `${emersonRoutes.shop.catalog}?${brandParams}`;
  };

  return (
    <Arrange spacing="large" isFullWidth>
      <Arrange spacing="xxsmall" isVertical>
        <Typography type="h2" isMarginless>
          {productName}
        </Typography>
        <Link href={getBrandPath()} isColor="system" isUnderLined={false}>
          <Typography type="h4" isMarginless css={styles.subtitle}>
            {brand.name}
          </Typography>
        </Link>
      </Arrange>
      <Columns preserveMobileColumns isMarginless>
        <Column columnWidth={6} isPaddingless>
          <Arrange spacing="xsmall" isVertical>
            <Typography isMarginless>{t(l.productDetails.EmersonItemCode)}</Typography>
            <Typography isSecondaryWeight>{sku}</Typography>
          </Arrange>
        </Column>
        <Column columnWidth={6} isPaddingless>
          <Arrange alignment="start" spacing="xsmall" isVertical>
            <Typography isMarginless>{t(l.productDetails.VendorItemCode)}</Typography>
            <Typography isSecondaryWeight>{vendorItemCode}</Typography>
          </Arrange>
        </Column>
      </Columns>
    </Arrange>
  );
};

export { ProductNameAndSku };
